import Link from "next/link";
import React from "react";

export default function index() {
  return (
    <div className="bg-darkBlue py-3 px-4 md:px-12 lg:px-[72px] items-center flex gap-2 justify-center">
      <p className="md:text-sm text-xs text-white/90 !text-center w-fit leading-tight">
        © 2024 Soul Scale. All Rights Reserved.
      </p>
      <Link
        href="/Soul Scale Privacy Notice.pdf"
        target="_blank"
        className="text-white md:text-sm text-xs text-white/90 underline"
      >
        Privacy Policy
      </Link>
    </div>
  );
}
